import { render } from "./Sso.vue?vue&type=template&id=a1ca2fd4"
import script from "./Sso.vue?vue&type=script&lang=js"
export * from "./Sso.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__